import { makeFormButtonsStyleSelector, makeFormLayoutSelector } from "@client/content/modules/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type FormProps } from "@client/controls/Form/component";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";

import Component, { type Props } from "./component";

export type ContainerProps = RootContainerProps &
  Omit<FormProps, "buttonsStyle" | "layout"> & {
    buttonsStyle?: React.CSSProperties;
  };
const makeMapStateToProps = () => {
  const formButtonsStyleSelector = makeFormButtonsStyleSelector(TargetSelector.Entity, "button");
  const formLayoutSelector = makeFormLayoutSelector(TargetSelector.Entity);

  return (state: AppState, props: ContainerProps): Partial<Props> => {
    return {
      ...props,
      buttonsStyle: props.buttonsStyle ?? formButtonsStyleSelector(state, props),
      layout: formLayoutSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps, null, { forwardRef: true })(Component);
